module.exports = __webpack_public_path__ + "img/ski_sub_title4-5m.40982430.png";